module.exports = __webpack_public_path__ + "static/media/DigitalLand.92ab95a6.jpg";